import { Avatar, Box, CardMedia, Typography } from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import { getPharmacyDashboardData } from "../../../redux/reducers/clinicSlice";

const PharmacyDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pharmacyDashboard } = useSelector((state) => state?.clinic);

  useEffect(() => {
    dispatch(getPharmacyDashboardData({ type: "Outpatient" }));
  }, []);

  const handleCardClick = (appointment) => {
    navigate("/pharmacy-pet-details", {
      state: { appointment: { appoinment: appointment?.appointment } },
    });
  };

  const getGroomAppointments = () => {
    return pharmacyDashboard;
  };

  const getStatus = (itm) => {
    let status = "Pending";
    const allItems = [
      ...(itm?.procedures ?? [])?.flatMap((p) =>
        p?.procedureDetails?.map((d) => d?.itemIssued)
      ),
      ...(itm?.prescriptions ?? [])?.flatMap((p) =>
        p?.prescriptionDetails?.map((d) => d?.itemIssued)
      ),
    ];
    if (allItems?.every((val) => val === "true")) {
      status = "Completed";
    } else if (allItems.every((val) => val === null)) {
      status = "Pending";
    } else {
      status = "Partially Completed";
    }
    return status;
  };

  const getTotalItemsCount = (itm) => {
    let count = 0;
    const procedureCount = itm?.procedures?.reduce(
      (sum, p) => sum + (p?.procedureDetails?.length || 0),
      0
    );

    const prescriptionCount = itm?.prescriptions?.reduce(
      (sum, p) => sum + (p?.prescriptionDetails?.length || 0),
      0
    );
    count = (procedureCount ?? 0) + (prescriptionCount ?? 0);
    return count;
  };

  return (
    <>
      <div
        className="flex-row-ali-cen back-white"
        style={{ padding: "12px 24px" }}
      >
        <div className="ph10pv3">
          <div className={`flex-center cursor pet-det-sel-tab`}>Overview</div>
        </div>
      </div>

      <Box className="pb-40 ph20">
        {/* Header */}
        <div className="flex-row-ali-cen">
          <div className="w10Per flex-center">
            <Typography className="txt-semi-bold fs16 blue-color">
              Time
            </Typography>
          </div>
          <div className="w90Per" />
        </div>

        {/* Appointments List */}
        <div className="mt20">
          {getGroomAppointments()?.map((itm) => {
            const apnt = itm?.appointment;
            return (
              <div key={apnt?.appointmentId} className="flex-row-ali-cen mb10">
                <div className="w10Per flex-center">
                  <div className="flex-center br5 txt-regular fs16 tim-con">
                    {moment(apnt?.appointmentdateTime).format("HH.mm")}
                  </div>
                </div>

                {/* Appointment Card */}
                <div className="w95Per pl20">
                  <div className="flex-row-ali-cen br15 lght-blu-bck-con">
                    {/* Pet Information */}
                    <div
                      className="flex-row-ali-cen w30Per cursor"
                      style={{ alignItems: "stretch" }}
                      onClick={() => handleCardClick(itm)}
                    >
                      <div
                        style={{
                          background: "#6d79fc",
                          width: 10,
                        }}
                        className="brl10"
                      />
                      <div className="ali-slf-cen pv10 ml5">
                        {apnt?.petImage ? (
                          <CardMedia
                            image={apnt?.petImage}
                            className="h50img ml5"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {apnt?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>

                      <div className="ml10 pv10">
                        <div className="flex-row">
                          <Custom3dotString
                            str={apnt?.petName}
                            className="txt-semi-bold fs14"
                            length={30}
                          />
                          <Typography
                            className={`txt-regular ml3 capitalize ${
                              apnt?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            ({apnt?.gender})
                          </Typography>
                        </div>
                        <Typography className="txt-regular card-black1 fs12 capitalize">
                          {apnt?.breed}
                        </Typography>
                        <div className="flex-row mt5">
                          <div className="flex-start">
                            <div className="flex-center">
                              <Avatar
                                src="/broken-image.jpg"
                                sx={{ width: 20, height: 20 }}
                              />
                            </div>
                          </div>
                          <div className="ml5 flex-center">
                            <Custom3dotString
                              str={apnt?.userName ?? ""}
                              className="font-bold fs12"
                              length={30}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Service Details */}
                    <div className="flex-row-ali-cen w60Per">
                      <Typography className="font-bold fs14 black back-white ph20 pv10 br5">
                        Medicines Administered /Prescribed:{" "}
                        {getTotalItemsCount(itm)}
                      </Typography>
                    </div>

                    {/* Status/Actions */}
                    <div className="w15Per">
                      <div
                        className={`fs10 font-medium white-color ph10 pv5 br5 con-fit ${
                          getStatus(itm) === "Pending"
                            ? "red-back2"
                            : getStatus(itm) === "Completed"
                            ? "green-back5"
                            : "card-top-orange-color"
                        }
                        `}
                      >
                        {getStatus(itm)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Box>
    </>
  );
};

export default PharmacyDashboard;
